import { createTheme } from "@mui/material/styles";

/**
 * Genera el tema de la aplicación basado en el modo (light/dark).
 * @param {'light' | 'dark'} mode El modo de color actual.
 * @returns El objeto de tema de Material UI.
 */
export const getTemaApp = (mode) => createTheme({
    palette: {
        mode,
        primary: {
            main: "#1976d2",
        },
        background: {
            default: mode === 'dark' ? "#121212" : "#f5f5f5",
            paper: mode === 'dark' ? "#1e1e1e" : "#ffffff",
        },
    },
    shape: {
        borderRadius: 14,
    },
    typography: {
        fontFamily: [
            "Inter",
            "system-ui",
            "-apple-system",
            "Segoe UI",
            "Roboto",
            "Arial",
            "sans-serif",
        ].join(","),
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 18,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    borderRadius: 14,
                    fontWeight: 600,
                },
            },
        },
    },
});
